import { useEffect, useState } from 'react';
import { Trash2, Mail, Phone, MailOpen } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Badge } from '../../components/ui/badge';
import api from '../../lib/api';
import { useToast } from '../../hooks/use-toast';

export default function AdminInquiries() {
  const [items, setItems] = useState([]);
  const { toast } = useToast();
  const load = () => api.get('/admin/inquiries').then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm('Delete this inquiry?')) return;
    await api.delete('/admin/inquiries/' + id);
    toast({ title: 'Deleted' });
    load();
  };

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-neutral-900">Inquiries</h1>
        <p className="text-sm text-neutral-500">{items.length} contact form submissions</p>
      </div>
      {items.length === 0 ? (
        <div className="bg-white p-12 rounded-xl border border-neutral-200 text-center">
          <MailOpen className="w-10 h-10 text-neutral-300 mx-auto mb-2" />
          <p className="text-neutral-500">No inquiries yet</p>
        </div>
      ) : (
        <div className="space-y-3">
          {items.map((q) => (
            <div key={q.id} className="bg-white p-5 rounded-xl border border-neutral-200">
              <div className="flex items-start justify-between gap-3">
                <div className="flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="font-bold text-neutral-900">{q.name}</h3>
                    <Badge variant="secondary">{q.subject}</Badge>
                    {q.property_id && <Badge className="bg-[#DC2626] text-white">Property Inquiry</Badge>}
                  </div>
                  <div className="mt-1 flex flex-wrap gap-4 text-xs text-neutral-500">
                    <a href={'mailto:' + q.email} className="flex items-center gap-1 hover:text-[#DC2626]"><Mail className="w-3 h-3" /> {q.email}</a>
                    {q.phone && <a href={'tel:' + q.phone} className="flex items-center gap-1 hover:text-[#DC2626]"><Phone className="w-3 h-3" /> {q.phone}</a>}
                    <span>{(q.created_at || '').slice(0, 16).replace('T', ' ')}</span>
                  </div>
                  <p className="mt-3 text-sm text-neutral-700 whitespace-pre-line">{q.message}</p>
                </div>
                <Button variant="outline" onClick={() => remove(q.id)} className="text-red-600 border-red-200"><Trash2 className="w-4 h-4" /></Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
